'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { MODAL_BACKGROUND_TRANSITION_TIMING, SLIDEIN_MODAL_TRANSITION_TIMING } from 'HubStyleTokens/times';
import TwoWayTransition from '../../transitions/TwoWayTransition';
import { ModalTransitionContextProvider } from '../../context/ModalTransitionContext';
import { getOverlayTransition } from './overlayTransitionMixin';
import UIDialog from '../UIDialog';
const totalTransitionTime = parseInt(SLIDEIN_MODAL_TRANSITION_TIMING, 10);
const overlayTransitionTime = parseInt(MODAL_BACKGROUND_TRANSITION_TIMING, 10);
const dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
const overlayTransition = getOverlayTransition(dialogTransitionTime);
const ModalPanelTransitionWrapper = styled(TwoWayTransition.PlainWrapper).withConfig({
  displayName: "ModalPanelTransition__ModalPanelTransitionWrapper",
  componentId: "dxb3u4-0"
})(["", "{transition-property:", ";transition-delay:", "ms;transition-duration:", "ms;transform:", ";}", ";"], UIDialog.Selector, ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', overlayTransitionTime, dialogTransitionTime, ({
  open,
  transitioning
}) => transitioning && `translateX(${open ? '0' : '100'}%)`, overlayTransition);

const ModalPanelTransition = props => /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
  ContextProvider: ModalTransitionContextProvider,
  duration: totalTransitionTime,
  transitionOnMount: true,
  Wrapper: ModalPanelTransitionWrapper
}));

ModalPanelTransition.displayName = 'ModalPanelTransition';
export default ModalPanelTransition;